import React from 'react';
import { ScrollReveal } from './ui/ScrollReveal';
import { BookOpenIcon, GiftIcon, ShieldIcon, LeafIcon, WindIcon } from 'lucide-react';
const items = [{
  icon: <BookOpenIcon className="w-8 h-8 text-forest" data-id="element-195" />,
  title: 'Ebook Principal: Botiquín Ancestral',
  desc: 'Guía Maestra 60 pág. El paso a paso para crear tus remedios.',
  isMain: true,
  value: '$45.000',
  image: null
}, {
  icon: <ShieldIcon className="w-6 h-6 text-amber" data-id="element-196" />,
  title: 'Bono Gratis 1: Guía Anti-Dengue Casera',
  desc: 'Repelentes naturales que sí funcionan y protegen a tu familia.',
  isMain: false,
  value: '$12.000',
  image: 'https://cdn.magicpatterns.com/uploads/kMFFpecijmLnvhujqYm6aV/BONO_1.png',
  imageAlt: 'Guía Anti-Dengue Casera'
}, {
  icon: <LeafIcon className="w-6 h-6 text-amber" data-id="element-197" />,
  title: 'Bono Gratis 2: Farmacia en Macetas',
  desc: 'Ideal para balcones y departamentos. Cultivá tu medicina.',
  isMain: false,
  value: '$15.000',
  image: 'https://cdn.magicpatterns.com/uploads/ngZmynXKjpQ1Z5rRXvVxDW/BONO_2.png',
  imageAlt: 'Farmacia en Macetas'
}, {
  icon: <GiftIcon className="w-6 h-6 text-amber" data-id="element-198" />,
  title: 'Bono Gratis 3: Diccionario de Dietéticas',
  desc: 'Comprá como experto y ahorrá hasta un 50% en insumos.',
  isMain: false,
  value: '$7.000',
  image: 'https://cdn.magicpatterns.com/uploads/3uxvavyrD1afYPfFepAYyK/BONO_3.png',
  imageAlt: 'Diccionario de Dietéticas'
}, {
  icon: <WindIcon className="w-6 h-6 text-amber" data-id="element-199" />,
  title: 'Bono Gratis 4: Protocolo Chau Resfrío 24hs',
  desc: 'Plan de choque natural para cortar síntomas rápido.',
  isMain: false,
  value: '$10.000',
  image: 'https://cdn.magicpatterns.com/uploads/bL1wwiHVKMCnFsNdiLBia6/BONO_4.png',
  imageAlt: 'Protocolo Chau Resfrío 24hs'
}];
export function ValueStack() {
  return <section className="py-20 bg-cream relative" data-id="element-200">
      <div className="max-w-4xl mx-auto px-4" data-id="element-201">
        <ScrollReveal data-id="element-202">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-brown mb-10" data-id="element-203">
            Esto es lo que recibís hoy:
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={100} data-id="element-204">
          <div className="mb-12" data-id="element-205">
            <img src="https://cdn.magicpatterns.com/uploads/3A3YCYFLBHQd2WKN5WLqGo/BUNDLE_1.png" alt="Bundle completo: Botiquín Ancestral + 4 Bonos" className="w-full max-w-3xl mx-auto rounded-2xl shadow-2xl border-2 border-amber/20" data-id="element-206" />
          </div>
        </ScrollReveal>

        <div className="space-y-6" data-id="element-207">
          {items.map((item, index) => <ScrollReveal key={index} delay={index * 150} data-id="element-208">
              <div className={`rounded-2xl border overflow-hidden ${item.isMain ? 'bg-white border-forest shadow-lg' : 'bg-white/60 border-amber/30 shadow-sm'} transition-transform hover:-translate-y-1`} data-id="element-209">
                <div className={`flex flex-col ${item.image ? 'md:flex-row' : ''} items-stretch`} data-id="element-210">
                  {/* Bonus Image */}
                  {item.image && <div className="md:w-52 shrink-0" data-id="element-211">
                      <img src={item.image} alt={item.imageAlt || item.title} className="w-full h-48 md:h-full object-cover" data-id="element-212" />
                    </div>}

                  {/* Text Content */}
                  <div className="flex-1 p-6 flex flex-col md:flex-row items-start md:items-center gap-4" data-id="element-213">
                    <div className={`p-3 rounded-full shrink-0 ${item.isMain ? 'bg-forest/10' : 'bg-amber/10'}`} data-id="element-214">
                      {item.icon}
                    </div>
                    <div className="flex-1" data-id="element-215">
                      <div className="flex flex-col md:flex-row md:items-center justify-between gap-2" data-id="element-216">
                        <h3 className={`font-bold text-lg md:text-xl ${item.isMain ? 'text-forest' : 'text-brown'}`} data-id="element-217">
                          {item.isMain ? '✅' : '🎁'} {item.title}
                        </h3>
                        <div className="flex items-center gap-2" data-id="element-218">
                          <span className="text-sm text-brown/40 line-through font-medium" data-id="element-219">
                            {item.value}
                          </span>
                          <span className={`text-sm font-bold px-2 py-1 rounded ${item.isMain ? 'text-forest bg-forest/10' : 'text-amber bg-amber/10'}`} data-id="element-220">
                            {item.isMain ? '$17.990' : '$0 GRATIS'}
                          </span>
                        </div>
                      </div>
                      <p className="text-brown/70 mt-1 font-sans" data-id="element-221">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal delay={800} data-id="element-222">
          <div className="mt-12 text-center bg-parchment p-6 rounded-xl border border-brown/10" data-id="element-223">
            <p className="text-lg text-brown/80" data-id="element-224">
              Valor total real:{' '}
              <span className="line-through font-bold text-red-600/70" data-id="element-225">
                $89.000
              </span>
            </p>
            <p className="text-2xl font-bold text-forest mt-2" data-id="element-226">
              Hoy te llevás todo por solo $17.990
            </p>
          </div>

          <div className="mt-8 text-center" data-id="element-227">
            <a href="#checkout" className="inline-block w-full md:w-auto bg-forest text-white font-bold text-lg md:text-xl px-8 py-5 rounded-xl animate-pulse-glow hover:bg-forest/90 transition-colors shadow-lg transform hover:-translate-y-1" data-id="element-228">
              🛒 SÍ, QUIERO MI BOTIQUÍN AHORA ($17.990)
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}